module.exports = __webpack_public_path__ + "static/media/pink-in-german.5da563f8.jpg";